module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/crypto-app-3-1422afb38df9af072b6cfd98ce18a196.png";